import axios from 'axios'
import {BedModel} from '../features/bed/model'
import {ResponseObject} from '../../../models'
import {ObjectIdModule} from '../features/modules/models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createBedService(dto: BedModel) {
  return await axios.post<ResponseObject<BedModel>>(`${BASEURL}/bed/createBed`, dto)
}

export async function deleteBedService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<BedModel>>(`${BASEURL}/bed/deleteBed`, {
    data: dto,
  })
}

export async function editBedService(dto: BedModel) {
  return await axios.put<ResponseObject<BedModel>>(`${BASEURL}/bed/updateBed`, dto)
}

export async function getBedByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<BedModel>>(`${BASEURL}/bed/getBedById`, {
    params: {
      Id: id,
    },
  })
}

export async function changeStatusBedService(
  estadoCamaId: string,
  subEstadoCamaId: string,
  data: any[],
) {
  return await axios.post<ResponseObject<any>>(
    `${BASEURL}/bed/statusChangeBed?estadoCamaId=${estadoCamaId}&subEstadoCamaId=${subEstadoCamaId}`,
    data,
  )
}
